// import Vue from 'vue';
// import store from '@/store/store';
import localStorageHelper from '../helpers/local-storage-helper';
import AppConstants from '../appConstants';

class ChangeZoom {
    setUltraCompact() {
        document.body.classList.add("zoom-ultra-compact");
        document.body.classList.remove("zoom-compact");
        document.body.classList.remove("zoom-default");
        document.body.classList.remove("zoom-big");
        document.body.classList.remove("zoom-ultra-big");
        localStorageHelper.updateZoom(AppConstants.ZOOM.ULTRACOMPACT);
    }
    setCompact() {
        document.body.classList.add("zoom-compact");
        document.body.classList.remove("zoom-default");
        document.body.classList.remove("zoom-big");
        document.body.classList.remove("zoom-ultra-compact");
        document.body.classList.remove("zoom-ultra-big");
        localStorageHelper.updateZoom(AppConstants.ZOOM.COMPACT);
    }
    setDefault() {
        document.body.classList.add("zoom-default");
        document.body.classList.remove("zoom-compact");
        document.body.classList.remove("zoom-big");
        document.body.classList.remove("zoom-ultra-compact");
        document.body.classList.remove("zoom-ultra-big");
        localStorageHelper.updateZoom(AppConstants.ZOOM.DEFAULT);
    }
    setMedium() {
        localStorageHelper.updateZoom(AppConstants.ZOOM.MEDIUM);
    }
    setBig() {
        document.body.classList.add("zoom-big");
        document.body.classList.remove("zoom-compact");
        document.body.classList.remove("zoom-default");
        document.body.classList.remove("zoom-ultra-compact");
        document.body.classList.remove("zoom-ultra-big");
        localStorageHelper.updateZoom(AppConstants.ZOOM.BIG);
    }
    setUltraBig() {
        document.body.classList.add("zoom-ultra-big");
        document.body.classList.remove("zoom-big");
        document.body.classList.remove("zoom-compact");
        document.body.classList.remove("zoom-default");
        document.body.classList.remove("zoom-ultra-compact");
        localStorageHelper.updateZoom(AppConstants.ZOOM.ULTRABIG);
    }


    setDetailCompact() {
        localStorageHelper.updateZoomDetail(AppConstants.ZOOM.COMPACT);
    }
    setDetailDefault() {
        localStorageHelper.updateZoomDetail(AppConstants.ZOOM.DEFAULT);
    }
    setDetailMedium() {
        localStorageHelper.updateZoomDetail(AppConstants.ZOOM.MEDIUM);
    }
    setDetailBig() {
        localStorageHelper.updateZoomDetail(AppConstants.ZOOM.BIG);
    }

}

export default new ChangeZoom();